<template>
  <div class="info-board">
    <div class="board-header">
      <h2>Aktuális infók</h2>
      <button v-if="isAdmin || isAssistant" class="btn-primary" @click="showForm = !showForm">
        {{ showForm ? 'Mégse' : '+ Új bejegyzés' }}
      </button>
    </div>

    <div v-if="showForm && (isAdmin || isAssistant)" class="info-form card">
      <input v-model="form.title" placeholder="Cím" class="modern-input" />
      <textarea v-model="form.body" placeholder="Szöveg" class="modern-input"></textarea>
      <div class="photo-upload">
        <label for="infoImage" class="file-label">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21,15 16,10 5,21"/>
          </svg>
          <span>{{ form.image ? form.image.name : 'Kattints a kép feltöltéshez' }}</span>
        </label>
        <input 
          id="infoImage" 
          type="file" 
          @change="onFile" 
          accept="image/*" 
          class="file-input"
        />
      </div>
      <button class="btn-primary" @click="submit">Mentés</button>
    </div>

    <div v-if="loading" class="muted">Betöltés…</div>
    <div v-else-if="items.length === 0" class="muted">Nincs megjeleníthető információ.</div>

    <div v-for="item in items" :key="item.id" class="info-card card">
      <img v-if="item.image_hash" :src="imgUrl(item.image_hash)" class="info-img" />
      <div class="info-body">
        <h3>{{ item.title }}</h3>
        <p>{{ item.body }}</p>
        <div class="info-meta">{{ formatDate(item.created_at) }}</div>
        <button v-if="isAdmin || isAssistant" class="btn-danger btn-sm" @click="remove(item.id)">Törlés</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CurrentInfoItem',
  data() {
    return {
      items: [],
      loading: true,
      showForm: false,
      form: { title: '', body: '', image: null },
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isAssistant() {
      return this.$store.getters.isAssistant;
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.loading = true;
      try {
        const r = await axios.get(this.$BACKEND_HOST + '/api/current-info');
        this.items = r.data.info || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    onFile(e) {
      this.form.image = e.target.files[0];
    },
    imgUrl(hash) {
      return this.$BACKEND_HOST + '/api/image/' + hash;
    },
    async submit() {
      const fd = new FormData();
      fd.append('title', this.form.title);
      fd.append('body', this.form.body);
      if (this.form.image) fd.append('image', this.form.image);
      await axios.post(this.$BACKEND_HOST + '/api/current-info', fd);
      this.form = { title: '', body: '', image: null };
      this.showForm = false;
      this.fetch();
    },
    async remove(id) {
      await axios.delete(this.$BACKEND_HOST + `/api/current-info/${id}`);
      this.fetch();
    },
    formatDate(d) {
      return d ? new Date(d).toLocaleString() : '';
    },
  },
};
</script>

<style scoped>
.info-board { max-width: 900px; margin: 0 auto; padding: 1.5rem; }
.board-header { display: flex; justify-content: space-between; align-items: center; }
.card { background: var(--card-bg); border: 1px solid var(--color-border); border-radius: 12px; padding: 1rem; margin-bottom: 1rem; }
.info-form { display: flex; flex-direction: column; gap: 0.6rem; }
.info-card { display: flex; gap: 1rem; }
.info-img { max-width: 180px; border-radius: 8px; object-fit: cover; }
.info-meta { color: var(--color-text-muted); font-size: 0.85rem; margin-top: 0.4rem; }
.muted { color: var(--color-text-muted); padding: 1rem; }
.btn-primary { background: var(--button-primary); color: #fff; border: none; padding: 0.5rem 1rem; border-radius: 8px; cursor: pointer; }
.btn-danger { background: #d33; color: #fff; border: none; padding: 0.35rem 0.7rem; border-radius: 6px; cursor: pointer; }
.btn-sm { font-size: 0.8rem; }
.photo-upload {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  position: relative;
}
.file-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  border: 2px dashed var(--color-border);
  border-radius: 10px;
  background: var(--color-background);
  color: var(--color-text-muted);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.file-label:hover {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
  background: var(--card-bg);
}
.file-label svg {
  flex-shrink: 0;
  opacity: 0.75;
}
.file-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}
</style>
